export default __webpack_public_path__ + "static/media/roadmap_1.353aca4f.png";